import { render } from "./CheckboxWidget.vue?vue&type=template&id=27d187f3&ts=true&lang=pug"
import script from "./CheckboxWidget.vue?vue&type=script&setup=true&lang=ts"
export * from "./CheckboxWidget.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__